<template>
    <div class="border-gray-200 border-b">
        <div class="p-5 mx-auto md:w-2/3 lg:w-1/2 xl:w-1/3 2xl:w-1/4">

            <p class="mb-5 font-medium">
                Do you agree to electronic communication?
            </p>

            <div v-html="template" class="overflow-y-auto max-h-96 p-4 mb-4 border-2 border-gray-200 rounded-lg" />

            <label class="flex items-center justify-center md:justify-start mb-4 text-xs">
                <input type="checkbox" class="form-control mr-2" id="econsent-check" :value="true" v-model="electronicConsentCheckbox" />
                &nbsp;I have read and agree to the terms and conditions.*
            </label>

            <div class="flex flex-col md:flex-row-reverse justify-between space-y-2 md:space-y-0">
                <button type="button" id="econsent-accept"
                    @click="accept(false)"
                    :class="{[
                        `text-white px-3 text-xs py-2 md:ml-1 border border-transparent shadow-sm leading-4 font-medium rounded-md focus:outline-none focus:ring-2 focus:ring-offset-2 bg-${$root.theme}-300 hover:bg-${$root.theme}-400 focus:ring-${$root.theme}-200`]: true,
                        'cursor-not-allowed': ! electronicConsentCheckbox
                    }">
                    Opt in to E-Communication
                </button>
                <div v-if="loading" class="hidden md:inline-block">
                    <i :class="`fa fa-spinner fa-spin text-${$root.theme}-300 fa-2x`"></i>
                </div>
                <button v-if="! electronicConsentCheckbox" type="button"
                    @click="showConfirmation = true"
                    :class="{[`text-black px-3 text-xs py-2 md:mr-1 border border-transparent shadow-sm leading-4 font-medium rounded-md focus:outline-none focus:ring-2 focus:ring-offset-2 bg-gray-300 hover:bg-gray-400 focus:ring-gray-200`]: true}">
                    Decline E-Communications
                </button>
                <div v-if="loading" class="md:hidden flex-initial flex justify-center items-center">
                    <i :class="`fa fa-spinner fa-spin text-${$root.theme}-300 fa-2x`"></i>
                </div>
            </div>

            <div class="fixed inset-0 overflow-y-auto" :class="{ 'z-10': showConfirmation, 'z-neg': ! showConfirmation }">
                <div class="flex items-center justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
                    <transition
                        enter-active-class="ease-out duration-300"
                        enter-class="opacity-0"
                        enter-to-class="opacity-100"
                        leave-active-class="ease-in duration-200"
                        leave-class="opacity-100"
                        leave-to-class="opacity-0">
                        <div class="fixed inset-0 transition-opacity" aria-hidden="true">
                            <div class="absolute inset-0 bg-gray-500 opacity-75" />
                        </div>
                    </transition>
                    <span class="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>
                    <transition
                        enter-active-class="ease-out duration-300"
                        enter-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                        enter-to-class="opacity-100 translate-y-0 sm:scale-100"
                        leave-active-class="ease-in duration-200"
                        leave-class="opacity-100 translate-y-0 sm:scale-100"
                        leave-to-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95">
                        <div v-show="showConfirmation" class="inline-block align-bottom bg-white rounded-lg pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-sm md:max-w-md sm:w-full" role="dialog" aria-modal="true" aria-labelledby="modal-headline">
                            <div>
                                <div class="mt-2">
                                    <h3 class="text-lg leading-6 font-medium text-gray-900 text-center" id="modal-headline">
                                        Confirmation
                                    </h3>
                                    <div class="mb-4 border-t border-b border-gray-200 bg-gray-50 text-left">
                                        <p v-if="! declinedTemplate" class="text-sm text-gray-500 p-4" style="max-height: 24rem; overflow-y: scroll;">
                                            Because you clicked declined. This means you will ONLY receive paper documents by mail, which may delay processing times to receive updates and notices related to your account. By receiving digital communications, you will receive these notices via e-mail or text which is much quicker and convenient.
                                        </p>
                                        <p v-else v-html="declinedTemplate" class="text-sm text-gray-500 p-4" style="max-height: 24rem; overflow-y: scroll;" />
                                    </div>
                                </div>
                            </div>
                            <div class="mt-5 px-4 sm:mt-6">
                                <div class="flex flex-col md:flex-row-reverse justify-between space-y-2 md:space-y-0">
                                    <button type="button"
                                        @click="accept(true)"
                                        :class="{[
                                            `text-white px-3 text-xs py-2 border border-transparent shadow-sm leading-4 font-medium rounded-md focus:outline-none focus:ring-2 focus:ring-offset-2 bg-${$root.theme}-300 hover:bg-${$root.theme}-400 focus:ring-${$root.theme}-200`]: true
                                        }">
                                        Opt in to E-Communication
                                    </button>
                                    <div v-if="loading" class="hidden md:inline-block">
                                        <i :class="`fa fa-spinner fa-spin text-${$root.theme}-300 fa-2x`"></i>
                                    </div>
                                    <button v-if="! electronicConsentCheckbox" type="button"
                                        @click="decline"
                                        :class="{[`text-black px-3 text-xs py-2 border border-transparent shadow-sm leading-4 font-medium rounded-md focus:outline-none focus:ring-2 focus:ring-offset-2 bg-gray-300 hover:bg-gray-400 focus:ring-gray-200`]: true}">
                                        Decline E-Communications
                                    </button>
                                    <div v-if="loading" class="md:hidden flex-initial flex justify-center items-center">
                                        <i :class="`fa fa-spinner fa-spin text-${$root.theme}-300 fa-2x`"></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </transition>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import Mixins from "../mixins";

    export default {
        mixins: [Mixins],

        props: {
            accountId: {},
            consumerPortalData: {},
            template: {},
            declinedTemplate: {},
            onLogin: {
                type: Boolean,
                default: () => false
            },
            source: {
                type: String
            }
        },

        data() {
            return {
                electronicConsentCheckbox: false,
                showConfirmation: false,
                loading: false
            }
        },

        mounted() {
            this.gtagEvent('electronic-consent-requested');

            if (this.onLogin) {
                this.gtagEvent('electronic-consent-requested-on-login');
            }

            this.viewed();

            this.$root.$refs.app.updatePageName('obtain-ecommunication-consent');
        },

        methods: {
            viewed() {
                this.$http.post(`${this.consumerPortalData.consumerPortalBaseUrl}/api/ecommunication-consent/${this.accountId}/viewed`, { source: this.source });
            },

            accept(override = false) {
                if (! override && ! this.electronicConsentCheckbox) return;

                if (this.loading) return;

                this.loading = true;

                this.showConfirmation = false;

                this.gtagEvent(
                    ! override
                        ? 'electronic-consent-accepted'
                        : 'electronic-consent-accepted-from-second-chance'
                );

                if (this.onLogin) {
                    this.gtagEvent(
                        ! override
                            ? 'electronic-consent-accepted-on-login'
                            : 'electronic-consent-accepted-from-second-chance-on-login'
                    );
                }

                let url = `${this.consumerPortalData.consumerPortalBaseUrl}/api/ecommunication-consent/${this.accountId}/${! override ? 'accepted' : 'accepted-from-second-chance'}`;

                this.$http
                    .post(url, { source: this.source })
                    .then(() => {
                        setTimeout(() => {
                            this.loading = false;

                            this.$emit('accepted');
                        }, 1000);
                    }, () => this.loading = false);
            },

            decline() {
                if (this.loading) return;

                this.loading = true;

                this.gtagEvent('electronic-consent-declined');

                if (this.onLogin) {
                    this.gtagEvent('electronic-consent-declined-on-login');
                }

                let url = `${this.consumerPortalData.consumerPortalBaseUrl}/api/ecommunication-consent/${this.accountId}/declined`;

                this.$http
                    .post(url, { source: this.source })
                    .then(() => {
                        setTimeout(() => {
                            this.loading = false;

                            this.$emit('declined');
                        }, 1000);
                    }, () => this.loading = false);
            }
        }
    }
</script>
